import { Content } from "@/ui/Content";
import { Collection } from "@sourceflow-uk/sourceflow-sdk";
import { getEvent } from "@/functions/getEvent";
import * as additionalComponents from "@/components/EventPage";
import { router } from "@/router";
import { parseRoute } from "@/functions/parseRoute";
import sourceflowEnums from "@/sourceflow.enums";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const event = getEvent(url_slug);

  const routerKey = "events.item";
  const routerProp = parseRoute(routerKey, { url_slug });

  return {
    props: {
      meta: {
        en: {
          title: event["title_en"],
          canonical: `${sourceflowEnums.config.baseUrl}${routerProp["en"]}`,
          image: event["image_en"],
        },
      },
      router: routerProp,
      content: [
        { component: "EventPageBannerSection", props: { event } },
        { component: "EventPageContentSection", props: { className: "pb-4 py-md-5", event } },
      ],
    },
  };
}

export async function getStaticPaths() {
  return {
    paths: (await Collection("events")).getItems().map((i) => ({ params: { url_slug: i.url_slug } })),
    fallback: false,
  };
}
